import { VisibilityButton } from "@msys/ui";
import { Tooltip } from "@mui/material";
import { useTranslate } from "@tolgee/react";

interface Props {
  isVisible: boolean;
  changeVisibility: (isVisible: boolean) => void;
  disabled: boolean;
}

export const ToggleClientVisibilityButton = ({
  isVisible,
  changeVisibility,
  disabled,
}: Props) => {
  const { t } = useTranslate(["FilesBoxTable"]);

  return (
    <Tooltip title={t("Set client visibility", { ns: "FilesBoxTable" })}>
      <VisibilityButton
        aria-label={t("Set client visibility", {
          ns: "FilesBoxTable",
        })}
        fontSize={"small"}
        isVisible={isVisible}
        onChange={changeVisibility}
        disabled={!changeVisibility || disabled}
      />
    </Tooltip>
  );
};
